import moment from "moment";
export default function (value, format = "DD MMM, yyyy HH:mm") {
  if (!value) return "-";
  return moment(value).format(format);
}
